import { render } from "./L_Window.vue?vue&type=template&id=47cccdc9"
import script from "./L_Window.vue?vue&type=script&lang=js"
export * from "./L_Window.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__